export const LOCAL_CONVEX_URL = import.meta.env.VITE_CONVEX_URL || 'https://api.elitestc.com';
